"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Journal = /*#__PURE__*/function () {
  function Journal(client) {
    (0, _classCallCheck2["default"])(this, Journal);
    this.client = client;
    this.resourceUrl = '/journals';
  }

  (0, _createClass2["default"])(Journal, [{
    key: "getGlobalJournals",
    value: function getGlobalJournals() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "?limit=").concat(limit, "&offset=").concat(offset), args);
    }
  }, {
    key: "getGlobalJournalsSignedURL",
    value: function getGlobalJournalsSignedURL(journalId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(journalId, "/signed-url"), args);
    }
  }, {
    key: "saveGlobalJournal",
    value: function saveGlobalJournal(journalId, data) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(journalId), data, args);
    }
  }, {
    key: "createGlobalJournal",
    value: function createGlobalJournal(data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.post("".concat(this.resourceUrl), data, args);
    }
  }, {
    key: "getProgramMediaJournals",
    value: function getProgramMediaJournals(moduleId, mediaId) {
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      for (var _len5 = arguments.length, args = new Array(_len5 > 4 ? _len5 - 4 : 0), _key5 = 4; _key5 < _len5; _key5++) {
        args[_key5 - 4] = arguments[_key5];
      }

      return this.client.get("/programs/".concat(moduleId, "/media/").concat(mediaId, "/journals?limit=").concat(limit, "&offset=").concat(offset), args);
    }
  }, {
    key: "getLibraryMediaJournals",
    value: function getLibraryMediaJournals(subCategoryId, mediaId) {
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      for (var _len6 = arguments.length, args = new Array(_len6 > 4 ? _len6 - 4 : 0), _key6 = 4; _key6 < _len6; _key6++) {
        args[_key6 - 4] = arguments[_key6];
      }

      return this.client.get("/medias/sub-categories/".concat(subCategoryId, "/").concat(mediaId, "/journals?limit=").concat(limit, "&offset=").concat(offset), args);
    }
  }]);
  return Journal;
}();

exports["default"] = Journal;